"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadType = void 0;
var FileUploadType;
(function (FileUploadType) {
    FileUploadType["PRODUCT"] = "PRODUCT";
    FileUploadType["PRICE_BOOK"] = "PRICE_BOOK";
    FileUploadType["LOTS"] = "LOTS";
    FileUploadType["USERS"] = "USERS";
    FileUploadType["TEAMS"] = "TEAMS";
    FileUploadType["ROLES"] = "ROLES";
    FileUploadType["PRICE_BOOK_ENTRIES"] = "PRICE_BOOK_ENTRIES";
    FileUploadType["CUSTOMERS"] = "CUSTOMERS";
})(FileUploadType = exports.FileUploadType || (exports.FileUploadType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlsZS11cGxvYWQtdHlwZS5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbW1vbi9lbnVtcy9maWxlLXVwbG9hZC10eXBlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUgsSUFBWSxjQVNYO0FBVEQsV0FBWSxjQUFjO0lBQ3hCLHFDQUFtQixDQUFBO0lBQ25CLDJDQUF5QixDQUFBO0lBQ3pCLCtCQUFhLENBQUE7SUFDYixpQ0FBZSxDQUFBO0lBQ2YsaUNBQWUsQ0FBQTtJQUNmLGlDQUFlLENBQUE7SUFDZiwyREFBeUMsQ0FBQTtJQUN6Qyx5Q0FBdUIsQ0FBQTtBQUN6QixDQUFDLEVBVFcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFTekIifQ==